/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// Importing icons for edit and delete actions
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

export default function Tr({
  id, // ID of the layer choice
  layer_name, // Name of the layer
  layer_url, // URL of the layer
  layer_preview_url, // Preview URL of the layer
  layer_preview_url_preview,
  order, // Order of the layer
  onEdit, // Function to handle the edit action
  onDelete, // Function to handle the delete action
  isAllowedToEditOrDelete, // Boolean flag to check if edit/delete is allowed
}) {
  return (
    <>
      <tr>
        <td className="first-col-td"><span className="extra_space_1">{layer_name}</span></td>
        <td className="col-numeric-date">
          <span className="extra_space_2">
            {/* Displaying the layer preview image */}
            <img src={layer_preview_url_preview} width={50} height={50} alt={"Layer Choice"} />
          </span>
        </td>
        <td className="col-numeric-date">{order}</td>
        <td className="col-options">
          {/* Edit action */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete
                ? onEdit({
                    id, // Pass the necessary data to the onEdit function
                    layer_url,
                    layer_preview_url,
                    layer_preview_url_preview,
                    order,
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
          </a>
          &nbsp;
          {/* Delete action */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete
                ? onDelete({
                    id, // Pass the necessary data to the onDelete function
                    layer_url,
                    delete: true, // Indicate that this is a delete action
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" />
          </a>
          &nbsp;
        </td>
      </tr>
    </>
  );
}
